import { useContext, useEffect, useRef } from 'react';
import { HelmetContext } from '../components/HelmetContext';

// Added an optional skipCleanup boolean parameter to useHelmet that prevents tag removal on component unmount.
export const useHelmet = (key, {
  data, props, error, history, skipCleanup = false
}, callback, deps) => {
  const { context, canUseDom } = useContext(HelmetContext);
  
  const stringKey = String(key);
  const idRef = useRef(stringKey);
  
  if (!context) {
    throw new Error('useHelmet requires a context object on the HelmetProvider');
  }

  context[key] = {
    id: idRef.current,
    args: { data, props, error },
    callback
  };

  useEffect(() => {
    let tags = callback({ data, props, error, history });
    if (!Array.isArray(tags) && tags) {
      tags = [tags];
    }
    // as tags get added from clientside you need to update dom.
    if (canUseDom && tags) {
      tags.forEach((tag) => {
        tag.updateDom();
      });
    }
    return () => {
      // console.log('im unmounting');
      if (skipCleanup) return;
      (tags || []).forEach((tag) => {
        tag.removeFromDom();
      });
    };
  }, deps);

  return idRef;
};
